import React from 'react';

import Dots from 'assets/img/icons/dots.svg';

import {ActionButtonStyled} from './styles';

export const ActionButton = (props) => {
    return (
        <ActionButtonStyled $css={props?.$css}>
            <div className="container" style={props?.style} onClick={props.handleClick}>
                <Dots style={{width: '100%', height: '100%'}} />
            </div>
        </ActionButtonStyled>
    );
};

export default ActionButton;
